// The giveaway image (data-special-giveaway-image) is kept in sync with the homepage
// offers graphic (home.offers.image_url) and the Official Rules link
// (data-special-rules-link) is kept in sync with the CMS-managed PDF
// (giveaway.rules.pdf_url, editable from the admin Files panel). Both are wired up in
// secondary.tsx so editors never need to touch this file.
export const win = `
# Enter Giveaway
<img id="image-full" src="https://operation-give-thanks.s3.us-east-1.amazonaws.com/website/january.png" data-special-giveaway-image="true" />
</br></br>
<div id="logged-in">
<a style="text-align:center;" href="/account/giveaway" id="button">Enter Giveaway</a>
</div>
<div style="text-align:center;" id="logged-out">
<a href="/account/login" id="button">Sign In</a>
<a href="/account/register" id="button">Register</a>
<a href="/account/giveaway" id="button">Enter as Guest</a>
</div>

<hr />

<div style="text-align:center;">
<a href="https://operation-give-thanks.s3.amazonaws.com/website/giveaway-rules.pdf" id="button" data-special-rules-link="true" target="_blank">Official Rules</a>
</div>
`;
